// LoadingScreen.js
import React, { useEffect, useState } from "react";
import { useDealershipContext } from "../../contexts/dealershipContext";
import UpdatePopup from "../UpdatePopup/UpdatePopup";
import "./LoadingScreen.scss";
import { useNavigate } from "react-router-dom";
import { useDealershipUserContext } from "../../contexts/dealershipUserContext";
import { useRecordingSessionContext } from "../../contexts/recordingSessionContext";

function ErrorPopup({ errorPopup, setErrorPopup, responseMessage }) {
  return (
    <>
      {errorPopup && (
        <UpdatePopup
          Popupshow={setErrorPopup}
          main={responseMessage}
          popupTimer={5000}
          popupStyle="error"
        />
      )}
    </>
  );
}

const LoadingScreen = ({ type }) => {
  const navigate = useNavigate();
  const { dealershipId, baseURL } = useDealershipContext();
  const { recordingEnabled } = useRecordingSessionContext();
  const { responseError, responseMessage, clearDealershipUserInfo } =
    useDealershipUserContext();

  const [errorPopup, setErrorPopup] = useState(false);

  useEffect(() => {
    if (responseError) {
      setErrorPopup(true);
    } else {
      setErrorPopup(false);
    }
  }, [responseError]);

  useEffect(() => {
    if (!errorPopup && responseError) {
      clearDealershipUserInfo();
      navigate(`${baseURL}matchmaker-quiz?audio=${recordingEnabled}`);
    }
  }, [errorPopup]);

  const { dealershipImgUrl } = useDealershipContext();

  if (type === "spinner") {
    return (
      <>
        <ErrorPopup
          errorPopup={errorPopup}
          responseMessage={responseMessage}
          setErrorPopup={setErrorPopup}
        />
        <div className="loading-screen">
          <div className="loader" />
        </div>
      </>
    );
  }

  const initializeCardsNum = () => {
    if (window.innerWidth < 600) {
      return 1;
    } else if (window.innerWidth < 850) {
      return 2;
    } else if (window.innerWidth < 1100) {
      return 3;
    } else if (window.innerWidth < 1250) {
      return 4;
    } else {
      return 5;
    }
  };
  const numCardsToShow = initializeCardsNum();

  return (
    <>
      <ErrorPopup
        errorPopup={errorPopup}
        responseMessage={responseMessage}
        setErrorPopup={setErrorPopup}
      />
      <div className="gallery-loader-container">
        <div className="gallery-loader-container__hero">
          <div className="gallery-loader-container__hero--main">
            <img className="loading-logo" alt="" src={dealershipImgUrl} />
            <button className="loading-btn skeleton" />
          </div>
        </div>
        <div className="loading_matches_page_heading">
          <div className="loading_matches_page_heading__container">
            <div className="loading-text skeleton" />
            <div className="loading-btn-container">
              <button className="loading-btn skeleton" />
              <button className="loading-btn skeleton" />
              <button className="loading-btn skeleton" />
              <button className="loading-btn skeleton" />
            </div>
          </div>
        </div>
        <div className="loading-card-container">
          {Array.from({ length: numCardsToShow }, (el, _) => el + 1).map(
            (_, i) => {
              return (
                <div className="loading-card" key={i}>
                  <img className="loading-card-image skeleton" alt="" />
                  <div className="loading-card-element-full skeleton" />
                  <div className="loading-card-element-full">
                    <div className="loading-card-element-half skeleton" />
                    <div className="loading-card-element-half skeleton" />
                  </div>
                  <div
                    className={`${numCardsToShow > 1 && i === numCardsToShow - 1 ? "loading-card-element-3-4" : "loading-card-element-full"}  skeleton`}
                  />
                </div>
              );
            }
          )}
        </div>
        {numCardsToShow < 4 && (
          <>
            <div className="loading-line-container">
              <div className="loading-line">
                <div className="loading-line-zap-right" />
              </div>
              <button className="loading-btn skeleton" />
              <div className="loading-line">
                <div className="loading-line-zap-left" />
              </div>
            </div>
            <div className="remaining-loading-container skeleton" />
          </>
        )}
      </div>
    </>
  );
};

export default LoadingScreen;
